import { render, staticRenderFns } from "./TipsAndTricksRent.vue?vue&type=template&id=9aa72a2a&scoped=true"
import script from "./TipsAndTricksRent.vue?vue&type=script&lang=ts"
export * from "./TipsAndTricksRent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa72a2a",
  null
  
)

export default component.exports